"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormService = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const store_1 = require("../store");
const index_1 = require("./index");
class FormService {
    constructor() {
        this.__priority = 100;
    }
    /**
     * Saves a form.
     *
     * @returns New, saved, form.
     */
    save(form) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            const formJSON = core_shared_1.IkeModel.Form.write(form);
            const newFormJSON = yield rest.save(rest.Objects.Form, formJSON);
            return core_shared_1.IkeModel.Form.read(newFormJSON);
        });
    }
    /**
     * Deletes a form.
     *
     * @returns Revision of deleted form.
     */
    remove(uuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            const startTime = Date.now();
            const result = yield rest.Form.delete({ uuid });
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Form, 'FORM_DELETE', `uuid: ${uuid}`, Date.now() - startTime);
            store_1.AppStore.FormSummary.refresh();
            return result.results.revision;
        });
    }
    /**
     * Shares a form with another department of the same organization.
     *
     * @returns New form revision.
     */
    share(revision, toDepartmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            const startTime = Date.now();
            const result = yield rest.Form.share({ revision, toDepartmentId });
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Form, 'FORM_SHARE', `revision:${revision} -> department:${toDepartmentId}`, Date.now() - startTime);
            return result.results.revision;
        });
    }
    copy(formId, toDepartmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            const startTime = Date.now();
            const result = yield rest.Form.copy({ formId, toDepartmentId });
            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Form, 'FORM_COPY', toDepartmentId ? `id:${formId} -> department:${toDepartmentId}` : `id:${formId}`, Date.now() - startTime);
            return result.results.formId;
        });
    }
}
exports.FormService = FormService;
//# sourceMappingURL=form.service.js.map